import React, { forwardRef, Fragment } from 'react';
import setting from "./setting";
import "./style.less";
import { EnhanceComponent } from "../../middleware/EnhanceComponent";
import { getPrefixCls } from "../../utils/common";
export var gdPrefix = 'gd';
var prefixCls = getPrefixCls('SmShare');
var Share = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$params, _props$schema, _props$schema$params;
  var source = ((_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.source) || ((_props$schema = props.schema) === null || _props$schema === void 0 ? void 0 : (_props$schema$params = _props$schema.params) === null || _props$schema$params === void 0 ? void 0 : _props$schema$params.source);
  var isDev = source === 'development';
  if (isDev) return /*#__PURE__*/React.createElement("div", null, "\u5206\u4EAB\u5360\u4F4D");
  return /*#__PURE__*/React.createElement(Fragment, null);
});
var EnhancedShare = EnhanceComponent(Share);
EnhancedShare.settings = setting;
export default EnhancedShare;